module.exports = __webpack_public_path__ + "media/assets/icons/ic-email-acec13b94476198f085a120058b6a25f.svg";